import { useCallback, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import Agent from "../../Network/Agent";
import { Link, useNavigate, useParams } from "react-router-dom";
import CountdownTimer from "../../Props/CountdownTimer";
import { cancelAllRequests, createController } from "../../Network/API";
import AcknowledgmentModel from "../../Models/AcknowledgmentModel";
import AlarmAcknowledgmentViewModal from "../../Models/AlarmAcknowledgmentViewModal";
import isTenantUser from "../../CustomHook/tenantUser";

export default function AcsActiveAlarm() {
    const ddd = useParams();
    const dispatch = useDispatch()
    const { user: profileUser } = useSelector((state) => state.profileReducer);
    const { user: authUser } = useSelector((state) => state.authReducer);
    const tenantUser = isTenantUser(profileUser?.id ? profileUser : authUser);
    const [page, setPage] = useState(1);
    const navigate = useNavigate();
    const [loading_export, setLoadingExport] = useState(false);
    const controllerRef = useRef(null);
 const [alarm,setAlarm]=useState();
 const [actionMode, setActionMode] = useState("ack");
  const [modalDialogUlock, setModalDialogUlock] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewAlarm, setViewAlarm] = useState(null);

     const openActionModal=(value, mode = "ack")=>{
        setAlarm(value)
        setActionMode(mode)
        setModalDialogUlock(true)
    }

    const openViewModal = (value) => {
        setViewAlarm(value);
        setIsViewModalOpen(true);
    }

    const stopRowClick = (event) => {
        event.stopPropagation();
    }

    const form_data = {
        site_id: "",
        tenant_id: "",
        alarm_type: "",
        from_date: "",
        to_date: "",
        page: 1,
        export_type: 2,
        loadMore: false,
    };

    const searchSite = (site_id) => {
        cancelAllRequests();
        const controller = createController();
        const signal = controller.signal;
        form_data.site_id = site_id;
        form_data.page = 1;
        Agent.RMS_ALARM.acs_active_alarm(dispatch, form_data, signal)
    }

    const reloadActiveAlarm = () => {
        cancelAllRequests();
        const controller = createController();
        const signal = controller.signal;
        form_data.alarm_type = ddd.id;
        form_data.page = 1;
        Agent.ACS_ALARM.acs_alarm_nav(dispatch, signal);
        Agent.RMS_ALARM.acs_active_alarm(dispatch, form_data, signal);
    }

    const [alarmType, setAlarmType] = useState('');



    useEffect(() => {
        document.title = "iMac | ACS Active Alarm"
        setAlarmType(ddd.id)
        cancelAllRequests();
        const controller = createController();
        const signal = controller.signal;


        Agent.ACS_ALARM.acs_alarm_nav(dispatch, signal);
        form_data.alarm_type = ddd.id
        Agent.RMS_ALARM.acs_active_alarm(dispatch, form_data, signal)
    }, [ddd.id])

    const handleClick = (link) => {
        if (link) {
            navigate(link);
        }
    };

    const copyToClipboard = (s_data) => {
        // Manually construct the text with line breaks between fields
        const formattedText = `
          Site ID: ${s_data.site_id}
          Operator Site ID: ${s_data.tenant_id_site_id}
          Tenant: ${s_data.tenant_name}
          Alarm Name: ${s_data.name}
          Alarm Time: ${s_data.alarm_start}
        `;

        // Create a temporary textarea element to copy the formatted text
        const textArea = document.createElement('textarea');
        textArea.value = formattedText;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        alert('Copied to clipboard!');
    };

    const lock_master_alarm = useSelector((state) => state.lockAlarmListReducer)
    const acs_active_selector = useSelector((state) => state.acsActiveAlarmSlice)

    const observer = useRef();
    const lastElementRef = useCallback((element) => {
        //element is the react element being referenced

        // disconnect observer set on previous last element
        if (observer.current) observer.current.disconnect();

        // if there's no more data to be fetched, don't set new observer
        if (!acs_active_selector?.data.has_more_page) return;

        // set new observer
        observer.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && acs_active_selector?.data.has_more_page) setPage((prev) => prev + 1);
        });

        // observe/monitor last element
        if (element) observer.current.observe(element);
    }, [acs_active_selector?.data.has_more_page]);

    const handleExport = async (e) => {
        setLoadingExport(true);
        e.preventDefault();
        try {
            cancelAllRequests();
            const controller = createController();
            const signal = controller.signal;
            form_data.alarm_type = alarmType;
            const response = await Agent.ACS_ALARM.export_active_alarm(form_data, signal);
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `acs_active_alarms.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoadingExport(false);
        }
        catch (error) {
            console.error('Export failed:', error);
            setLoadingExport(false);
        }
    };

    return (<>

        <div className="row g-2 mt-2 mb-2">
            <div className="col-md-3 p-3">
                <div className="scroll-side-rms">
                    <table className="table table-borderless bg-white p-2 rounded">
                        <tr className="bg-dark text-white ro">
                            <td style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }} className="p-1 clickable">
                                <label className="form-check-label " >
                                    All Active Alarms
                                </label>
                            </td>
                            <td style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }}>
                                <span style={{ padding: '8px' }} className={`badge ${lock_master_alarm?.data?.total_alarm > 0 ? 'badge-secondary-red' : 'badge-secondary'} rounded-pill`}>{lock_master_alarm?.data?.total_alarm}</span>
                            </td>
                        </tr>
                        {!lock_master_alarm?.loading && lock_master_alarm?.data?.lock_alarms?.map((alarm, index) => (
                            <>


                                <tr >
                                    <td onClick={() => handleClick(`/acs_alarm_filter/${alarm.order_list}/fatch`)} style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }} className="p-1 clickable">
                                        <label className="form-check-label " htmlFor={`flexCheckDefaultRms${alarm.id}`}>
                                            {alarm.name}
                                        </label>
                                    </td>
                                    <td style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }}>
                                        <span style={{ padding: '8px' }} className={`badge ${alarm.value > 0 ? 'badge-secondary-red' : 'badge-secondary'} rounded-pill`}>{alarm.value}</span>
                                    </td>
                                </tr>


                            </>
                        ))}
                    </table>

                </div>
            </div>
            <div className="col-md-9 p-3">

                <div className="row g-2 mb-2">

                    <div className="col-md-8">
                        <h6 className="m-0 p-0">Total Alarms: {acs_active_selector?.data?.total_page}</h6>
                        <p className="p-0 m-0 fs-12">Current Display 1 - {acs_active_selector?.data?.alarms?.length} Record(s), {acs_active_selector?.data?.total_page} Record(s) Totally</p>

                    </div>
                    <div className="col-md-4 text-end ">

                        <div className="input-group input-group-sm">
                            <input type="text" onKeyUp={(e) => searchSite(e.target.value)} className="form-control form-control-sm" placeholder="Search by site id...." aria-label="Search" aria-describedby="basic-addon1" />

                            <a href="#" onClick={(e) => handleExport(e)} class="input-group-text btn btn-sm btn-info" id="basic-addon2"> <i className="fa-light fa-file-excel"></i> Export {loading_export ? (
                                <span
                                    className="spinner-border spinner-border-sm ms-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : (
                                <span></span>
                            )}</a>
                        </div>


                    </div>
                </div>
                <div className="table-responsive custom-table-responsive scroll-side-rms-active ">


                    <table className="table custom-table text-center ">
                        <tbody>
                            {acs_active_selector?.loading ? <p className='text-center text-dark fw-medium'>Loading...</p> : ''}
                            {!acs_active_selector?.loading && acs_active_selector?.data?.alarms?.length === 0 ? <p className='text-center text-dark fw-medium'>No Data Found</p> : ''}
                            {!acs_active_selector?.loading && acs_active_selector?.data?.alarms?.map((alarm, index) => (
                                <>
                                    <tr
                                        className="bg-white clickable"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => openViewModal(alarm)}
                                        ref={index === acs_active_selector?.data?.alarms.length - 1 ? lastElementRef : undefined}
                                    >
                                        <td>
                                            <i
                                                onClick={(e) => {
                                                    stopRowClick(e);
                                                    copyToClipboard(alarm);
                                                }}
                                                className="fa fa-copy text-success"
                                                style={{ fontSize: '20px', cursor: 'pointer' }}
                                            />

                                        </td>
                                        <td width="7%">
                                            <div className="signal-bars mt1 sizing-box good four-bars">
                                                <span>
                                                    <img src="/assets/icon/6.svg" className="tower-height" alt="" />
                                                </span>
                                                <div className={`first-bar bar ${alarm.network >= 1 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`second-bar bar ${alarm.network >= 2 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`third-bar bar ${alarm.network >= 3 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`fourth-bar bar ${alarm.network >= 4 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`fifth-bar bar ${alarm.network >= 5 ? '' : 'null-color'}`}>
                                                </div>
                                            </div>
                                        </td>
                                        <td width="6%" className="status" rel={alarm.id} data-value={alarm.site_id}>
                                            <p className="tr-header">SITE ID</p>
                                            <p className="tr-header-sub fw-bold">
                                                <Link to={`/site/${alarm.site_id}`} onClick={stopRowClick}>{alarm.site_id}</Link>
                                            </p>
                                        </td>
                                        <td width="12%">
                                            <p className="tr-header">Tenant</p>
                                            <p className="tr-header-sub ">{alarm.tenant_name}</p>
                                        </td>
                                        <td width="10%" >
                                            <p className="tr-header">Operator Site</p>
                                            <p className="tr-header-sub fw-bold">
                                                <Link to={`/site/${alarm.site_id}`} onClick={stopRowClick}>{alarm.tenant_site_id}</Link>
                                            </p>
                                        </td>
                                        <td width="25%">
                                            <p className="tr-header">Alarm Name</p>
                                            <p className="tr-header-sub">
                                                {alarm.name}
                                            </p>
                                        </td>
                                        <td width="15%">
                                            <p className="tr-header">Alarm Time</p>
                                            <p className="tr-header-date">
                                                {alarm.alarm_start}

                                            </p>
                                        </td>

                                        <td width="20%" className="elisp_time">
                                            <p className="tr-header">Elapsed Time</p>
                                            <p className="tr-header-sub elisp_time">
                                                {alarm.alarm_end != null ?
                                                    <span className="elisp_time">{alarm.total_elaspsed}</span>
                                                    :
                                                    <CountdownTimer targetDate={alarm.alarm_start} />
                                                }


                                            </p>
                                        </td>
                                        {!tenantUser && (
                                        <td width="10%">
                                            <p className="tr-header">Action</p>
                                            <div className="d-flex justify-content-center gap-2">
                                                <button
                                                    onClick={(e) => {
                                                        stopRowClick(e);
                                                        openActionModal(alarm, "ack");
                                                    }}
                                                    className="btn btn-sm btn-outline-primary"
                                                    type="button"
                                                    title="Acknowledge"
                                                >
                                                    <i className="fa-light fa-check"></i>
                                                </button>
                                                {(alarm.alarm_type==6 || alarm.alarm_type==1) && (
                                                    <button
                                                        onClick={(e) => {
                                                            stopRowClick(e);
                                                            openActionModal(alarm, "clear");
                                                        }}
                                                        className="btn btn-sm btn-outline-danger"
                                                        type="button"
                                                        title="Clear Alarm"
                                                    >
                                                        <i className="fa-light fa-close"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                        )}
                                    </tr>
                                    <tr className="spacer"><td colSpan={100} /></tr>
                                </>
                            ))}
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
            <AcknowledgmentModel type='2' alarm={alarm} mode={actionMode} isModalVisible={modalDialogUlock} handleShowB={() => setModalDialogUlock(false)} onSuccess={reloadActiveAlarm}/>
            {viewAlarm && (
                <AlarmAcknowledgmentViewModal
                    isOpen={isViewModalOpen}
                    onClose={() => setIsViewModalOpen(false)}
                    alarm={viewAlarm}
                    type={2}
                />
            )}

    </>)
}